import gql from "graphql-tag";
import { assignmentFragment } from "@/graphql/assignment/assignmentFragments";

export const CONFIRMASSIGNMENTCANCEL = gql`
    mutation confirmAssignmentCancel (
        $id: ID!
    ){
        confirmAssignmentCancel(
            id: $id
        ){
            ...assignmentFragment
        }
    }
    ${assignmentFragment}
`